import { __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { useTheme } from '../../hooks/useTheme.js';

var ToggleTipArrow = function ToggleTipArrow(_a) {
    var _b = _a.height, height = _b === void 0 ? 8 : _b, _c = _a.width, width = _c === void 0 ? 16 : _c, sx = _a.sx;
    var handleStyleProps = useTheme().handleStyleProps;
    var baseStyle = {
        height: "".concat(height, "px"),
        width: "".concat(width, "px"),
        position: "absolute",
        fill: "black.100",
    };
    var forwardProps = handleStyleProps({ sx: sx }, { baseStyle: baseStyle });
    return (jsx("svg", __assign({ "aria-hidden": "true", focusable: "false", width: "16", height: "8", viewBox: "0 0 16 8", xmlns: "http://www.w3.org/2000/svg", preserveAspectRatio: "none", className: "toggle-tip-arrow" }, forwardProps, { children: jsx("path", { d: "M0 8L16 8L9.41421 1.41421C8.63317 0.633165 7.36684 0.633164 6.58579 1.41421L0 8Z" }) })));
};

export { ToggleTipArrow };
//# sourceMappingURL=ToggleTipArrow.js.map
